import type { Device } from "../../../shared/models/device";
import { createDataStore } from "../lib/data_store";

const deviceStore = createDataStore<Device[] | undefined>();

export const useDevices = deviceStore.useDataSuspense;
export const setDevices = deviceStore.setData;
